var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdfs(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.646 21.524v3.98h-2.149l3.715 4.289 3.717-4.288h-1.994v-3.981zm1.505-2.643a6.56 6.56 0 11-.002 13.118 6.56 6.56 0 01.002-13.118zM6.244 16.839v1.399h9.819v-1.399zm0-6.061v1.398h14.067v-1.398zM17.901.99l4.425 4.708h-3.492a.932.932 0 01-.933-.932zM5.311 0h11.243v5.025c0 1.116.905 2.021 2.02 2.021h4.716v10.115a8.24 8.24 0 00-1.139-.087c-4.614 0-8.366 3.753-8.366 8.366 0 1.079.213 2.108.586 3.057h-9.06a2.021 2.021 0 01-2.021-2.021V2.021C3.29.905 4.195 0 5.311 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfs);
export default ForwardRef;